/* eslint-disable */
import React from "react";
import {
  createStyles,
  Card,
  Grid,
  Text,
  ThemeIcon,
  Center,
  Loader,
} from "@mantine/core";
import {
  IconCalendar,
  IconCheck,
  IconClock,
  IconX,
  IconArrowUpRight,
} from "@tabler/icons-react";
import { useGetMonthlyLeavesSummary } from "api/leaveReport/getsummaryMonthReport";

const useStyles = createStyles((theme) => ({
  grid: {
    width: "100%",
    height: "100%",
    // backgroundColor: "blue",
  },
  statCard: {
    margin: "0px",
    borderRadius: theme.radius.md,
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray[2]}`,
    boxShadow: "0 1px 0 rgba(0,0,0,0.02)",
    height: "100%",
    // padding: "16px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: theme.spacing.sm,
    gap: theme.spacing.md,
  },
  leftCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minWidth: 0,
  },
  title: {
    color: "black",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.2,
    marginBottom: 6,
  },
  count: {
    fontSize: 26,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 2,
    wordBreak: "break-word",
  },
  footerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: theme.spacing.xs,
  },
  pill: {
    fontSize: 12,
    fontWeight: 500,
    color: "black",
  },
  percent: {
    color: theme.colors.green[6],
    fontWeight: 600,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  iconWrap: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    marginLeft: theme.spacing.md,
  },
}));

export default function LeaveStatsCards() {
  const { classes, theme } = useStyles();
  const { data, isLoading, isError } = useGetMonthlyLeavesSummary(12, 2025);

  const unifiedColor = theme.colors.cyan ? theme.colors.cyan[5] : "#06b6d4";

  if (isLoading)
    return (
      <Center style={{ height: "200px" }}>
        <Loader />
      </Center>
    );

  if (isError)
    return (
      <Center style={{ height: "200px" }}>
        <Text color="red">Failed to load monthly leave summary.</Text>
      </Center>
    );

  const summary = data?.data;

  const statItems = [
    {
      id: "total",
      title: "Total Leaves",
      count: summary?.totalLeaves.count ?? 0,
      percent: `+${summary?.totalLeaves.percentage ?? 0}%`,
      Icon: IconCalendar,
    },
    {
      id: "approved",
      title: "Approved Leaves",
      count: summary?.approvedLeaves.count ?? 0,
      percent: `+${summary?.approvedLeaves.percentage ?? 0}%`,
      Icon: IconCheck,
    },
    {
      id: "pending",
      title: "Pending Requests",
      count: summary?.pendingRequests.count ?? 0,
      percent: `+${summary?.pendingRequests.percentage ?? 0}%`,
      Icon: IconClock,
    },
    {
      id: "rejected",
      title: "Rejected Leaves",
      count: summary?.rejectedLeaves.count ?? 0,
      percent: `+${summary?.rejectedLeaves.percentage ?? 0}%`,
      Icon: IconX,
    },
  ];

  return (
    <Grid>
      {statItems.map((it) => {
        const IconComp = it.Icon;
        return (
          <Grid.Col key={it.id} xs={12} sm={6} md={6} lg={6} xl={6} style={{}}>
            <Card className={classes.statCard} radius="md">
              <div className={classes.headerRow}>
                <div className={classes.leftCol}>
                  <Text className={classes.title}>{it.title}</Text>
                  <Text className={classes.count}>{it.count}</Text>
                </div>

                <div className={classes.iconWrap}>
                  <ThemeIcon
                    size={44}
                    radius={44}
                    variant="filled"
                    style={{
                      background: unifiedColor,
                      border: "none",
                    }}
                  >
                    <IconComp size={20} stroke={1.8} color="white" />
                  </ThemeIcon>
                </div>
              </div>

              <div className={classes.footerRow}>
                <Text className={classes.pill}>This Month</Text>
                <div className={classes.percent}>
                  <IconArrowUpRight size={12} stroke={1.6} />
                  <Text size="xs">{it.percent}</Text>
                </div>
              </div>
            </Card>
          </Grid.Col>
        );
      })}
    </Grid>
  );
}
